import { ReactNode, useState } from "react";
import { useSelector } from "react-redux";

import { FlyoutMenuContextProvider } from "@/components/Navigation/FlyoutMenu/context/flyoutMenu.context";
import { ActiveCategoryIndexes } from "@/components/Navigation/FlyoutMenu/types/activeCategoryIndexes.type";
import { useThunkDispatch } from "@/redux/dispatcher";
import * as FlyoutCategoriesSelectors from "@/redux/modules/value/flyoutCategories/flyoutCategories.selectors";
import * as HeaderModule from "@/redux/modules/value/header/header.module";
import * as HeaderSelectors from "@/redux/modules/value/header/header.selectors";

type Props = {
    children: ReactNode;
};

export const Base = ({ children }: Props) => {
    const [activeCategoryIndexes, setActiveCategoryIndexes] =
        useState<ActiveCategoryIndexes>([0, null, null, null]);

    const dispatch = useThunkDispatch();

    const open = useSelector(HeaderSelectors.isFlyoutActive);

    const rootCategory = useSelector(
        FlyoutCategoriesSelectors.getFlyoutCategories
    );

    const handleOnClose = () => {
        dispatch(
            HeaderModule.update({
                flyoutActive: false
            })
        );

        setActiveCategoryIndexes([0, null, null, null]);
    };

    if (!rootCategory) return null;

    return (
        <FlyoutMenuContextProvider
            open={open}
            rootCategory={rootCategory}
            activeCategoryIndexes={activeCategoryIndexes}
            setActiveCatetoryIndexes={setActiveCategoryIndexes}
            onClose={handleOnClose}
        >
            {children}
        </FlyoutMenuContextProvider>
    );
};
